import { useEffect, useState } from 'react';

export const useHasVisited = () => {
  const [hasVisited, setHasVisited] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const t = window.localStorage.getItem('hasVisited');
      if (t) {
        setHasVisited(true);
      } else {
        setHasVisited(false);
        window.localStorage.setItem('hasVisited', 'true');
      }
    }
  }, []);
  return { hasVisited };
};
